module.exports = __webpack_public_path__ + "197dd5d85d364d5d7ef13d2420d9bb95.pdf";